const { addActions } = require('js-data-http')

let mapper_options = {
  endpoint: 'retailers',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      retailer_account: {
        foreignKey: 'retailer_account_id',
        localField: 'retailer_account'
      },
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      }
    },
    hasMany: {
      facebook_page: {
        localKeys: 'facebook_page_ids',
        localField: 'facebook_pages'
      },
      facebook_share: {
        foreignKey: 'retailer_id',
        localField: 'facebook_shares'
      },
      twitter_account: {
        localKeys: 'twitter_account_ids',
        localField: 'twitter_accounts'
      },
      allocation_detail: {
        foreignKey: 'retailer_id',
        localField: 'allocation_details'
      },
      pulse_location: {
        foreignKey: 'retailer_id',
        localField: 'pulse_locations'
      },
      note: {
        foreignKey: 'retailer_id',
        localField: 'notes'
      },
      registration_key: {
        foreignKey: 'retailer_id',
        localField: 'registration_keys'
      }
    }
  }
}

module.exports = (store) => {
  let mapper = store.defineMapper('retailer', mapper_options)
  addActions({
    add_to_retailer_account: {
      pathname: ' ',
      method: 'POST'
    }
  })(mapper)
}
